'use client';

import { ensureIsFromArr } from '@eliadmin/core/src/utils/misc-utils';
import { useCallback, useSyncExternalStore } from 'react';

export enum CartStep {
  DETAIL = 'detail',
  PAYMENT_SHIPMENT = 'payment-shipment',
  ORDER = 'billing',
  SUMMARY = 'summary',
}

const CART_STEP_CHANGE_EVENT = 'ea:cart-step-change';

function subscribe(onChange: () => void) {
  window.addEventListener('popstate', onChange);
  window.addEventListener(CART_STEP_CHANGE_EVENT, onChange);
  return () => {
    window.removeEventListener('popstate', onChange);
    window.removeEventListener(CART_STEP_CHANGE_EVENT, onChange);
  };
}

function getSearchSnapshot() {
  return window.location.search;
}

export function useCartStepper() {
  const search = useSyncExternalStore(subscribe, getSearchSnapshot, () => '');
  const searchParams = new URLSearchParams(search);
  const currentStep = ensureIsFromArr(
    searchParams.get('cs') as CartStep,
    Object.values(CartStep),
    CartStep.DETAIL,
  );

  const currentStepIndex = Object.values(CartStep).indexOf(currentStep);

  const setStep = useCallback((step: CartStep) => {
    const url = new URL(window.location.href);
    url.searchParams.set('cs', step);
    window.history.pushState(window.history.state, '', url);
    window.dispatchEvent(new Event(CART_STEP_CHANGE_EVENT));
  }, []);

  return {
    currentStepIndex,
    currentStep,
    setStep,
  };
}
